import { Component, inject, signal, afterNextRender } from '@angular/core';
import { NgClass } from '@angular/common';
import { RouterLink } from '@angular/router';
import { LanguageService, SupportedLocale } from '../../../services/language.service';

@Component({
  selector: 'app-navbar',
  imports: [NgClass, RouterLink],
  templateUrl: './navbar.html',
  styleUrl: './navbar.css',
})
export class Navbar {
  private langService = inject(LanguageService);

  isScrolled = signal(false);
  isMenuOpen = signal(false);
  currentLocale = this.langService.getCurrentLocale();

  toggleMenu(): void {
    this.isMenuOpen.update((open) => !open);
  }

  closeMenu(): void {
    this.isMenuOpen.set(false);
  }

  constructor() {
    afterNextRender(() => {
      this.isScrolled.set(screen.height * 0.3 < 400);

      window.addEventListener('scroll', () => {
        this.isScrolled.set(window.scrollY > screen.height * 0.3);
      });
    });
  }

  switchLanguage(locale: SupportedLocale): void {
    this.langService.switchLanguage(locale);
  }

  scrollToServices(): void {
    this.closeMenu();
    document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' });
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    if (typeof window !== 'undefined') {
      window.removeEventListener('scroll', () => {});
    }
  }
}
